{
  "enum": {
    "ExcPlaidV1ProcessorTokenStatus": {
      "ACTIVE": "Active",
      "EXPIRED": "Expired",
      "PENDING": "Pending",
      "RETIRED": "Retired",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "ExcPlaidV1ProcessorTokenQueryServiceProcessorTokenListFilterableFields": {
      "accountId": "Account",
      "data": {
        "sourceId": "Source"
      },
      "processorTokenId": "Processor Token ID",
      "programId": "Program",
      "status": "Status"
    }
  },
  "oneOf": {
    "ExcPlaidV1ProcessorTokenEventType": {
      "activated": "Activated",
      "expired": "Expired",
      "requested": "Requested",
      "retired": "Retired",
      "updated": "Updated"
    }
  },
  "sortEnum": {
    "ExcPlaidV1ProcessorTokenQueryServiceProcessorTokenListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}